<template>
  <div class="card accompagnement-card h-100 shadow-sm">
    <div class="card-img-top-wrapper">
      <img
        src="@/assets/img/photo/senior-floor.jpg"
        class="card-img-top"
        :alt="$t('complexeUrgenceResume.image.alt')"
      />
    </div>

    <div class="card-body d-flex flex-column">
      <h5 class="fw-bold" style="font-size: 1.3rem">
        {{ $t("complexeUrgenceResume.title") }}
      </h5>

      <p class="text-muted" style="font-size: 1rem; line-height: 1.4">
        {{ $t("complexeUrgenceResume.text.p1") }}
      </p>

      <a
        href="/situations-complexes-urgences"
        class="btn btn-custom mt-2 w-100 mt-auto"
      >
        {{ $t("complexeUrgenceResume.button.more") }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComplexeUrgenceResume",
};
</script>

<style></style>
